module.exports = "../dist/img/img_4-35.c7ae.jpg";